var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Account =
/*#__PURE__*/
function () {
  "use strict";

  function Account(id) {
    _classCallCheck(this, Account);

    this._id = id;
    this._key_id = {};
    this._key_pair = {};
  }

  _createClass(Account, [{
    key: "addKeyPair",
    value: function addKeyPair(kp) {
      var permission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if (permission === "") {
        permission = this._key_id[kp.id];

        if (!permission) {
          throw 'key pair not exist';
        }
      }

      this._key_pair[permission] = kp;
    }
  }, {
    key: "getID",
    value: function getID() {
      return this._id;
    }
  }, {
    key: "getKeyPair",
    value: function getKeyPair(permission) {
      return this._kp[permission];
    }
  }, {
    key: "sign",
    value: function sign(t, permission) {
      t.addSign(this._key_pair[permission]);
    }
  }, {
    key: "signTx",
    value: function signTx(t) {
      t.addPublishSign(this._id, this._key_pair["active"]);
    }
  }], [{
    key: "import",
    value: function _import(json) {
      var obj = JSON.parse(json); // TODO
    }
  }]);

  return Account;
}();

module.exports = Account;